import React from 'react';

export default function VideoLogo() {
  return (
    <img alt="workfellow" className="videoLogo" src="https://workfellow.info/logo.png" width="96" height="96"></img>
  );
}
